<template>
    <div>
        <el-form class="evaluation-form-scoped" label-width="200px">
            <el-form-item label="评价意见" required>
                <el-radio-group v-model="form.userViewpoint" ref="userViewpoint">
                    <el-radio v-for="(item, index) in viewPointOptions" class="mr-20" :label="item.value" :key="index" v-if="item.value != '-1'">{{item.text}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="岗位建议方向"  required v-if="advise.length">
                <el-checkbox-group v-model="form.hireAdvice" ref="hireAdvice">
                    <el-checkbox v-for="(item, index) in advise" class="mr-20" :label="item" :key="index">{{item}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="综合评价" required  ref="content">
                <el-input class="text-content" :maxlength="2000" placeholder="请输入评价内容" type="textarea" v-model="form.content"></el-input>
            </el-form-item>
        </el-form>
        <society-form-tips :isSociety="this.recruitType !== 'campus'"></society-form-tips>
        <div class="button-footer">
            <el-button type="primary" @click="submit">提交评估</el-button>
            <el-button @click="cancel">取消</el-button>
        </div>
    </div>
</template>

<script>
    import SelectMapMixin from 'mixins/selectMapMixin'
    import SocietyBaseForm from './society-form-base'
    import SocietyFormTips from './society-form-tips.vue'

    export default{
        mixins: [SelectMapMixin],
        extends: SocietyBaseForm,
        data () {
            return {
                form: {
                    userViewpoint: '',
                    hireAdvice: [],
                    content: ''
                }
            }
        },
        props: {
            recruitType: null,
            isEdit: false,
            extInfo: null
        },
        components: {
            SocietyFormTips
        }
    }
</script>
<style lang="scss">
    @import "../evaluation-form";
</style>



// WEBPACK FOOTER //
// society-form-normal.vue?41573614